import { DatePicker, Toggles } from '@/components'
import { MonthSelect } from '@/components/ui/month-select'
import { useTranslate } from '@ur-solutions/react-hooks'
import { CalendarDays, CalendarRange } from 'lucide-react'
import type { ExportPeriod } from './export-period'
import { ExportField } from './export-field'

interface ExportPeriodFieldProps {
  value: ExportPeriod
  wide?: boolean
  onChange(value: Partial<ExportPeriod>): void
}

export const ExportPeriodField: React.FC<ExportPeriodFieldProps> = ({
  value,
  wide,
  onChange,
}) => {
  const translations = useTranslate({
    period: 'common.period',
    month: 'common.month',
    dateRange: 'exports.form.date-range',
  })

  return (
    <ExportField
      label={translations.period}
      wide={wide}
      labelRight={
        <Toggles
          value={value.useDateRange ? 'range' : 'month'}
          size="sm"
          options={[
            {
              value: 'month',
              label: (
                <span className="flex items-center gap-1.5 px-1 text-xs">
                  <CalendarDays size={14} />
                  {translations.month}
                </span>
              ),
            },
            {
              value: 'range',
              label: (
                <span className="flex items-center gap-1.5 px-1 text-xs">
                  <CalendarRange size={14} />
                  {translations.dateRange}
                </span>
              ),
            },
          ]}
          onChange={mode => onChange({ useDateRange: mode === 'range' })}
        />
      }
    >
      {value.useDateRange ? (
        <DatePicker
          mode="range"
          format="PP"
          value={{ from: value.dateStart, to: value.dateEnd }}
          onChange={range => {
            if (!range?.from) return
            onChange({
              dateStart: range.from,
              dateEnd: range.to ?? range.from,
            })
          }}
        />
      ) : (
        <MonthSelect
          className="w-full!"
          value={value.month}
          futureYears={0}
          disableAfter
          noYearCycle
          onChange={month => onChange({ month })}
        />
      )}
    </ExportField>
  )
}
